export default function fileVttSvg () {
  return `
    <svg id="file-vtt-svg" width="160" height="130" viewBox="-10 -100 700 700">
      <use xlink:href="/img/icons/file-vtt.svg#file-vtt-svg" ></use>
    </svg>
  `
}
